<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202504_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202504_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>花粉・黄砂・PM2.5…9割の方が見落としてるかも</span><br>春の肌荒れ、実は“洗うケア”が盲点</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">与えるスキンケアばかりになっていませんか？</h3>
        <p class="mb-3">春になると花粉・黄砂・PM2.5といった微粒子が空気中に多く舞い、知らず知らずのうちに肌に付着して炎症や乾燥を引き起こす原因になっていることをご存知でしょうか。</p>
        <p class="mb-3">実際、20代、30代、40代以上の女性の多くが「春になると肌の調子が不安定になる」と感じており、その背景にはこうした“見えない外的刺激”が影響していることも。</p>
        <p class="mb-3">しかし、お肌トラブルの対策として“洗顔”や“クレンジング”に注目している人はわずか。</p>
        <p>9割の方が見落としていた「洗うケア」の重要性と、今日から始められる改善策とは？</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_02.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">キレイな肌への近道は"落とすケア"
</h3>
        <p class="mb-3">では、どれくらいの女性が実際に「花粉・黄砂・PM2.5」による肌トラブルを経験していると感じているのでしょうか。</p>
        <p class="mb-3">そして、そのお肌悩みに対してどのようなお肌対策をしているのでしょう。</p>
        <p>春夏は守るためのケアに集中する方も多いと思います。マスクや日焼け止めでしっかりガードしつつも、大切な洗顔やクレンジングといった「落とすケア」を簡単にすませていませんか？</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">みんなが感じている肌トラブルは「かゆみ」「乾燥」</h3>
        <p class="mb-3">はじめに、「花粉・黄砂・PM2.5による肌トラブルが起きたことがあるか」について尋ねたところ、<strong>約6割</strong>の方が<strong>『よくある（21.2％）』『たまにある（40.4％）』</strong>と回答。</p>
        <p class="mb-3">やはり多くの方が何らかの肌トラブルを経験しており、春先にかけて肌の不調を感じているようです。</p>
        <p class="mb-3">肌トラブルの内容としては</p>
        <p class="mb-3"><strong>『かゆみ（71.8％）』<br>『乾燥（61.3％）』<br>『ヒリヒリした痛み（26.9％）』</strong></p>
        <p class="mb-3">といった、バリア機能の低下による刺激反応が中心となっており、外的刺激により肌が過敏になる様子がうかがえます。</p>
        <p>また、4人に1人がいつものスキンケアが合わなくなるという変化を経験。これまで問題なかったアイテムであっても、季節や環境変化によりトラブルが生じやすくなることがわかりました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_04.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">今年も春の肌トラブルを感じた方は約8割...！</h3>
        <p class="mb-3">続花粉・黄砂・PM2.5による肌トラブルを『よくある』『たまにある』と感じている方に、2025年も同様の肌トラブルが起きたかを尋ねたところ、『はい』と答えた方は79.6％にものぼりました。</p>
        <p class="mb-3">これは、過去の経験にとどまらず、今年も実際に肌の不調を感じた方が多かったことを意味しています。</p>
        <p class="mb-3">年による多少の差はあっても、『また今年も肌が荒れた』という実感が、春の恒例のように定着していることが読み取れます。</p>
        <p>花粉や黄砂は一時的なものと思われがちですが、肌トラブルに悩む方にとっては“毎年訪れる肌の危機”として捉えられているようです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">春の肌トラブルの対策は「外出時のマスク・メガネ・帽子の使用」が多い？</h3>
        <p class="mb-3">花粉・黄砂・PM2.5による肌トラブルを感じている方のうち、約7割が<strong>「とてもしている（16.8％）」「ややしている（55.0％）」</strong>と、何らかの対策を講じていることがわかりました。</p>
        <p class="mb-3">しかし一方で、<strong>「あまりしていない（23.8％）」「まったくしていない（4.4％）」</strong>という回答もあり、全員が十分な対策を行っているとは言い切れません。</p>
        <p class="mb-3">特に「ややしている」という回答が多いことからは、「どこまでやれば良いのかわからない」といった迷いも見受けられます。</p>
        <p class="mb-3">具体的な対策としては</p>
        <p class="mb-3"><strong>「マスク・メガネ・帽子などで肌の露出を減らす（66.7％）」<br>「スキンケアやメイクアイテムの見直し（37.4％）」<br>「保湿重視のケアへの切り替え（36.9％）」</strong></p>
        <p>と続き、“外的刺激のブロック”と“肌のバリア機能の回復”の両面から意識的にケアしている様子がうかがえます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_06.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">8割の方がクレンジング＆洗顔アイテムの見直しで肌荒れ改善を実感</h3>
        <p class="mb-3">では「スキンケア・メイクアイテムの見直し・変更」を行った方に具体的な内容を聞いたところ</p>
        <p class="mb-3"><strong>「保湿を重視したアイテムにした（62.7％）」<br>「洗浄力や肌へのやさしさを考えたクレンジング・洗顔にした（56.6％）」<br>「敏感肌用のアイテムにした（43.4％）」</strong></p>
        <p class="mb-3">が続き、“刺激を与えない”“潤いを守る”という観点が重視されていることがわかりました。</p>
        <p class="mb-3">さらに、クレンジングや洗顔アイテムを見直したことで「肌トラブルが改善したか」を尋ねたところ、<strong>約8割が「とても改善した（17.0％）」「やや改善した（59.6％）」</strong>と回答。</p>
        <p class="mb-3">洗顔やクレンジングの見直しは、肌悩みに対して高い効果を発揮することが明らかになりました。</p>
        <p>毎日の習慣の中で無理なく取り入れられる<strong>“洗うケア”</strong>こそ、春の肌トラブルに立ち向かう第一歩といえるかもしれません。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">約9割が「クレンジング・洗顔の見直しは見落としがちだと思う」</h3>
        <p class="mb-3">花粉・黄砂・PM2.5による肌トラブル対策として、クレンジングや洗顔の見直しはどの程度重要視されているのでしょうか。</p>
        <p class="mb-3">対策をしている方の、<strong>約9割が「クレンジング・洗顔の見直しは見落としがちだと思う」</strong>と回答しており、普段のケアの中で意識されにくい盲点であることが浮き彫りになりました。</p>
        <p class="mb-3">しかしその一方で、同じく約9割の方が「花粉・黄砂・PM2.5対策としてクレンジング・洗顔アイテムの見直しは重要」と回答しており、見落とされがちでありながらも、その<strong>必要性は多くの人が認識</strong>している状況です。</p>
        <p class="mb-3">日々のルーティンに組み込まれているからこそ、“洗い方”や“アイテム選び”をあらためて見直す機会は少なくなりがち。</p>
        <p>だからこそ、いま注目すべきケアのポイントといえるのかもしれません。肌トラブル対策の本質は、実は一番身近な“洗う”行為の中に隠されているのです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_08.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202504_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">ポイントはやさしい洗浄力などの"落とすケア"</h3>
        <p class="mb-3">最後に、花粉・黄砂・PM2.5による肌トラブル対策を意識している方々に、「理想的なクレンジング・洗顔アイテムとはどのようなものか」を尋ねました。</p>
        <p class="mb-3"><strong>「肌にやさしい（59.9％）」<br>「肌の汚れがしっかり落ちる（45.7％）」<br>「メイクがしっかり落ちる（41.0％）」</strong></p>
        <p class="mb-3">この回答から<strong>「強すぎない洗浄力」と「確かな効果」</strong>のバランスが重視されていることが明らかになりました。</p>
        <p class="mb-3">特に「肌荒れを防ぐ」「刺激が少ない」といった“予防ケア”を意識した項目の支持が高く、<strong>クレンジングや洗顔は単なる“落とす”工程ではなく、“肌を守るための第一ステップ”として認識されている傾向</strong>が見て取れます。</p>
        <p class="mb-3">一方で、「洗浄力が高い（24.3％）」は下位にとどまり、強すぎる洗浄はむしろ肌トラブルの原因になるという不安がうかがえました。</p>
        <p>こうした結果から、春の肌トラブル対策において求められているのは、<strong>「落とす力」だけでなく「守るやさしさ」を兼ね備えたクレンジング・洗顔アイテム</strong>であることがわかります。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202504_10.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h2 class="mb-3">肌トラブル対策において、クレンジング・洗顔の見直しは“効果があるのに見落とされがち”な盲点</h2>
        <p class="mb-3">今回の調査から、花粉・黄砂・PM2.5といった外的刺激が肌に与える影響は一過性ではなく、毎年繰り返される“生活課題”として定着していることが明らかになりました。特に「かゆみ」や「乾燥」といったトラブルを訴える声が多く、春先になると日ごろのスキンケアが合わなくなる“肌状態の揺らぎ”を感じる方も少なくありません。</p>
        <p class="mb-3">その対策として、「マスク・メガネ・帽子の着用」や「保湿の強化」「スキンケアアイテムの見直し」などさまざまなアプローチが取られていますが、中でもクレンジングや洗顔の見直しは高い改善効果が期待できるにもかかわらず、十分に注目されていないのが実情です。</p>
        <p>実際に、肌へのやさしさや洗浄力を意識した洗顔アイテムに変えたことで肌トラブルが改善したという声は多数。しかし、毎日の習慣であるがゆえに、アイテムや手順を見直す“意識の転換”がまだ浸透しきれていないのです。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p>なめらかで透明感のある肌のために、今日からできることは</p>
        <p class="mb-3 fs-2">クレンジング・洗顔アイテムを見直し</p>
        <p class="mb-3">マナビス化粧品のアイテムは、植物由来のお肌に<br>優しいスキンケアアイテムばかり。</p>
        <p class="mb-3">お肌の調子が気になるとき、ついつい美容液やスペシャルなパックなど、<br>"与えるケア"に集中する方が多いですが</p>
        <p class="mb-3">それらのアイテムも、実はクレンジングと洗顔による<br>お肌の土台作りがとても大切なのです。</p>
        <p class="mb-3">特に洗顔は朝も、お化粧をしない日も<br>ほとんどの方が必ずやっているスキンケアルーティン。</p>
        <p>美しい肌を目指すなら、毎日のルーティンケアを効果的に<br>バージョンアップすることがポイントであり、近道！</p>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000012.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000012.000124389.html">【花粉・黄砂・PM2.5…】春の肌荒れ、実は“洗うケア”が盲点？9割が“見落としがち”と回答</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「花粉・黄砂・PM2.5による肌トラブル」に関する調査<br>
        【調査期間】2025年4月3日（木）～2025年4月4日（金）<br>
        【調査方法】「PRIZMA」によるインターネット調査<br>
        【調査人数】1,004人<br>
        【調査対象】調査回答時に美容に関心のある20～40代の女性と回答したモニター<br>
        【モニター提供元】PRIZMAリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>